import React, {useEffect, useState} from 'react';
import {connect} from "react-redux";
import Joyride, { ACTIONS, EVENTS, LIFECYCLE, STATUS } from 'react-joyride';
import GuideAssistantTooltip from "./GuideAssistantTooltip.jsx";
import GuideAssistantContent from "./GuideAssistantContent";
import {getMessageValue} from "@ignitesales/neuro-application/src/i18n/messageUtil";
import {useIntl} from "react-intl";

//TODO: enable analytic tracking here using context pattern...don't wanna do a useless connect() call today (i.e. guideAssistant.started.id)

const GuideAssistant = (
  {
    delay,
    disable,
    enforceCache,
    onChange,
    id,
    pageType,
    steps,
    stepContentComponent,
    user,
    ...controlledState
  }) => {

  const [ run, setRun ] = useState(!delay);
  const intl = useIntl();
  const className = 'guide-assistant';
  const classNameModifier = `${className}--${pageType || id}`;
  const cacheKey = `${user.uuid || 'noUUID'}-guideAssistant`;
  const StepContent = stepContentComponent || GuideAssistantContent;

  useEffect(() => {
    setTimeout(() => {
      setRun(true);
    }, delay)
  }, []);

  const stepsConfiguration = (steps || []).map((config) => {
    const {target, id, content, ...rest} = config;
    return {
      target,
      title: getMessageValue(intl.locale, `${id}.title`),
      content: (<StepContent content={content} {...config}/>),
      ...rest
    }
  });

  const changeBodyClass = data => {
    const { index, action } = data;
    const bodyEl = document.body;

    const modifier = `${className}--`;
    const bodyClasses = bodyEl.classList || [];
    bodyClasses.forEach( bodyClass => {
      if(bodyClass && bodyClass.includes(modifier)){
        bodyEl.classList.remove(bodyClass);
      }
    });

    if(action === ACTIONS.STOP){
      bodyEl.classList.remove(className);
      bodyEl.classList.remove(classNameModifier);
    }else{
      bodyEl.classList.add(className);
      bodyEl.classList.add(classNameModifier);
      bodyEl.classList.add(`${modifier}step-${index}`);
    }
  };

  const updateCache = () => {
    const completedKeys = JSON.parse(window.sessionStorage.getItem(cacheKey));
    window.sessionStorage.setItem(cacheKey, JSON.stringify({
      ...completedKeys,
      [id]: new Date()
    }));
  };

  const hasAlreadyRun = () => {
    const completedKeys = JSON.parse(window.sessionStorage.getItem(cacheKey));
    const hasBeenRun = !!completedKeys?.[id];
    return enforceCache && hasBeenRun;
  };

  const callback = data => {
    const { action } = data;
    changeBodyClass(data);
    if(action === ACTIONS.STOP || action === ACTIONS.RESET) {
      updateCache(data);
    }
    onChange && onChange({
      ...data,
      id,
      hasCompleted: hasAlreadyRun
    });
  };

  return <Joyride
    steps={stepsConfiguration}
    callback={callback}
    tooltipComponent={GuideAssistantTooltip}
    disableOverlayClose={true}
    run={!disable && !hasAlreadyRun() && run}
    // @TODO link Joyride locale messages to global messages file
    locale= {{ open: '' }}
    { ...controlledState }
  />
};

export default connect((state) => {
  const processingNavigation = state.processingNavigation || false;
  const user = state.user || {};

  return {
    location,
    processingNavigation,
    user
  };
})(GuideAssistant);

export {
  ACTIONS,
  EVENTS,
  LIFECYCLE,
  STATUS
};
